import Reports from '@/UI/pages/reports/lib/Reports';
import { IReports, IReportsRepository, IReportsResponseType } from '@/UI/pages/reports/lib/Reports_IT';
import Api from '@/repository/api';

export default class reportsRepository implements IReportsRepository {
    async fetchAll(data?: FormData): Promise<IReports> {
        const response = await Api.get(`/report/service_report`,
            {params: data, paramsSerializer: function paramsSerializer(params) {
            return new URLSearchParams(params).toString()
        }});
        const responseData = response.data as IReportsResponseType;
        return new Reports(responseData);
    }
}


